import * as _ from 'lodash'
import React from 'react';
import componentServices from '../componentServices';
import * as contractorActions from '../contractorActions';
import globalRelay from '../globalRelay';
import util from '../util';
import jobCostPaymentTermFactory from '../models/jobCostPaymentTermModel';
import { BalanceSection, TermsSection } from './jobCostEditFinalizeShared';
import { Radio } from './sharedComponents';
import { getCollection, getModel, ModelCollection } from '../store';

const RejectionTable = ({ getEmployeeByUserId, onRejectionResolvedChange, rejectionStatus, rejectionResolved = '0' }) => {
	const rejector = getEmployeeByUserId(rejectionStatus.createdById);
	const rejectionrResolvedButtons = [
		{ classNames: ['icon yes'], isSelected: (rejectionResolved === '1'), value: '1' },
		{ classNames: ['icon no'], isSelected: (rejectionResolved === '0'), value: '0' }
	];

	const rejectionResolvedRadio = (<Radio buttons={ rejectionrResolvedButtons } onChange={ onRejectionResolvedChange } />);

	return (<table cellPadding="0" cellSpacing="0">
		<tbody>
			<tr>
				<td />
				<td><strong>Rejected By</strong></td>
				<td>{ rejector && rejector.fullName }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Rejected On</strong></td>
				<td>{ util.dateHelper.formatDate(rejectionStatus.dateCreated, { userFriendly: true }) }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Reason</strong></td>
				<td>{ rejectionStatus.description }</td>
				<td />
			</tr>
			{ /*  If user selects Yes below, set TR className to 'yes' or if No, set it to 'no' */ }
			<tr className={ rejectionResolved === '1' ? 'yes' : rejectionResolved === '0' ? 'no' : '' }>
				<td />
				<td><strong>Has this been resolved?</strong></td>
				<td>
					{ rejectionResolvedRadio }
				</td>
				<td />
			</tr>
		</tbody>
	</table>);
};

const InfoTable = ({ changeOrder, onInfoCorrectChange, infoCorrect = '0' }) => {
	const infoCorrectButtons = [
		{ classNames: ['icon yes'], isSelected: (infoCorrect === '1'), value: '1' },
		{ classNames: ['icon no'], isSelected: (infoCorrect === '0'), value: '0' }
	];

	const infoCorrectRadio = (<Radio buttons={ infoCorrectButtons } onChange={ onInfoCorrectChange } />);

	return (<table cellPadding="0" cellSpacing="0">
		<tbody>
			<tr>
				<td />
				<td><strong>Change Name</strong></td>
				<td>{ changeOrder.name }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Reason</strong></td>
				<td>{ changeOrder.description }</td>
				<td />
			</tr>
			<tr>
				<td />
				<td><strong>Who is Paying?</strong></td>
				<td>{ changeOrder.transactionAccount }</td>
				<td />
			</tr>
			<tr className={ infoCorrect === '1' ? 'yes' : infoCorrect === '0' ? 'no' : '' }>
				<td />
				<td><strong>Is this information correct?</strong></td>
				<td>
					{ infoCorrectRadio }
				</td>
				<td />
			</tr>
		</tbody>
	</table>);
};

export default class JobCostFinalizeChangeOrder extends React.Component<any,any> {
	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);

		this.handleButtonClick = this.handleButtonClick.bind(this);
		this.onInfoCorrectChange = this.onInfoCorrectChange.bind(this);
		this.onRejectionResolvedChange = this.onRejectionResolvedChange.bind(this);
		this.onTermsChange = this.onTermsChange.bind(this);
		this.calculateTerms = this.calculateTerms.bind(this);
		this._calculateTerms = this._calculateTerms.bind(this);
	}

	UNSAFE_componentWillReceiveProps (newProps) {
		this.setState(this.getStateFromProps(newProps));
	}

	getStateFromProps (props) {
		const { store } = componentServices;
		const { jobCost, summary } = props;
		const state = _.assign({ infoCorrect: undefined, rejectionResolved: undefined, contractAmount: summary.grandTotalContract, termAmount: 0 }, this.state);
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const globalConfig = globalRelay.config!;
		const builder = job.builderKey ? getModel({ store, collection: ModelCollection.contractors, key: job.builderKey }): undefined;

		if ((!job.builderKey || builder) && (state.jobCostKey !== jobCost.key || state.jobCostItemVersion !== jobCost.itemVersion)) {
			const contract = jobCost.proxiedContract;
			const changeOrder = jobCost.currentChangeOrder;

			state.builder = builder;
			state.isLocked = ['unlocked', 'rejected'].indexOf(changeOrder.currentStatus) === -1;
			state.isClosed = changeOrder.currentStatus === 'closed';
			state.infoCorrect = (!state.isLocked || state.isClosed) ? undefined : '1';

			state.job = job;
			state.contract = contract;
			state.changeOrder = changeOrder;
			state.jobCostKey = jobCost.key;
			state.jobCostItemVersion = jobCost.itemVersion;

			let paymentTermsKey = (builder && builder.paymentTermsKey);

			if (changeOrder.type === 'change-order' && summary.grandTotalSell && ['Builder', 'Homeowner'].indexOf(changeOrder.transactionAccount) !== -1) {
				paymentTermsKey = (builder && changeOrder.transactionAccount === 'Builder' && builder.paymentTermsKey);
				if (!paymentTermsKey) {
					if (state.contractAmount < 500) {
						paymentTermsKey = 'dueUponSigning';
					}
					else if (state.contractAmount <= 1500) {
						paymentTermsKey = 'fiftyFifty';
					}
					else {
						paymentTermsKey = 'default';
					}
				}
			}

			if (paymentTermsKey) {
				state.termConfig = _.assign({}, globalConfig.jobCostSettings.paymentTerms[paymentTermsKey] || globalConfig.jobCostSettings.paymentTerms.default);

				this._calculateTerms(false, state);
			}
		}

		if (!builder && job.builderKey) {
			contractorActions.fetchContractor({ key: job.builderKey });
		}

		return state;
	}

	getEmployeeByUserId (userId) {
		const { store } = componentServices;
		const employees = getCollection({ store, collection: ModelCollection.employees });

		return employees.find(f => f.user.key === userId);
	}

	onInfoCorrectChange (newButton) {
		if (['unlocked', 'rejected'].indexOf(this.state.changeOrder.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.infoCorrect = newButton.value;

			return newState;
		});
	}

	onRejectionResolvedChange (newButton) {
		if (['unlocked', 'rejected'].indexOf(this.state.changeOrder.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.rejectionResolved = newButton.value;

			return newState;
		});
	}

	calculateTerms (reset) {
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			this._calculateTerms(reset, newState);

			return newState;
		});
	}

	_calculateTerms (reset, state) {
		const { jobCost } = this.props;
		const { changeOrder } = state;
		const totalDue = state.contractAmount;
		const existingTerms = reset ? [] : _.sortBy(jobCost.paymentTerms, ['sortIndex']);
		const existingTotal = reset ? _.reduce(existingTerms, (sum, t) => util.roundAsCurrency(sum + util.roundAsCurrency(t.amountDue)), 0) : 0;

		state.termAmount = 0;
		state.termItems = _.map(existingTerms.length ? existingTerms : state.termConfig.payments, term => {
			let amountDue = term.amountDue;

			if (typeof amountDue === 'undefined') {
				amountDue = util.roundAsCurrency(term.percentDue * totalDue);
			}
			else if (reset) {
				amountDue = util.roundAsCurrency((amountDue / existingTotal) * totalDue);
			}

			state.termAmount = util.roundAsCurrency(state.termAmount + amountDue);

			return jobCostPaymentTermFactory({
				changeOrderKey: changeOrder.key,
				key: term.key || util.generateGuid(),
				sortIndex: term.sortIndex,
				description: term.description,
				amountDue: amountDue
			});
		});

		if ((reset || !existingTerms.length) && totalDue !== state.termAmount) {
			const diff = totalDue - state.termAmount;
			const lastItem = _.last(state.termItems);
			lastItem.amountDue = util.roundAsCurrency(lastItem.amountDue + diff);
			state.termAmount = util.roundAsCurrency(state.termAmount + diff);
		}
	}

	onTermsChange (newTerms) {
		const { contractAmount } = this.state;
		let termAmount = util.roundAsCurrency(_.reduce(newTerms, (sum, t) => util.roundAsCurrency(sum + util.roundAsCurrency(t.amountDue)), 0));

		if (contractAmount !== termAmount) {
			const diff = contractAmount - termAmount;
			const lastItem = _.last(newTerms);
			lastItem.amountDue = util.roundAsCurrency(lastItem.amountDue + diff);
			termAmount = util.roundAsCurrency(termAmount + diff);
		}

		this.setState({ termItems: newTerms, termAmount: termAmount });
	}

	canFinalize () {
		const { builder, changeOrder, contractAmount, infoCorrect, rejectionResolved, termAmount, termConfig } = this.state;
		const statusPasses = changeOrder.currentStatus !== 'rejected' || (changeOrder.currentStatus === 'rejected' && rejectionResolved === '1');
		const balance = !termConfig ? 0 : Number((contractAmount - termAmount).toFixed(2));
		const builderPasses = changeOrder.transactionAccount !== 'Builder' || changeOrder.currentStatus === 'locked' || !builder || builder.currentStatus !== 'locked';

		return builderPasses && statusPasses && infoCorrect === '1' && balance === 0;
	}

	handleButtonClick () {
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);

		if (!this.canFinalize() || saveState !== 0) { return; }

		const { summary } = this.props;
		const { termItems } = this.state;

		this.props.updateModel(jobCost => {
			const changeOrder = jobCost.currentChangeOrder;
			const changeOrderKey = changeOrder.key;

			if (['unlocked', 'rejected'].indexOf(changeOrder.currentStatus) !== -1) {
				changeOrder.statusLog.add({ status: 'locked' });

				// 28jul2023 - this used to also check for !!summary.grandTotalSell but Mike F determined it was likely not needed
				if (changeOrder.type === 'change-order') {
					// lock in tax and warranty costs
					summary.writeCalculatedItems(jobCost.proxiedContract, changeOrderKey);
					summary.writeStats(jobCost.proxiedContract, changeOrderKey);

					// 28jul2023 - added check for !!summary.grandTotalSell to prevent problems with payment terms based on above change
					// we need to clear the terms for this change order and then write the new terms
					if(summary.grandTotalSell) {
						_.forEach(jobCost.paymentTerms, ti => jobCost.paymentTerms.delete(ti.key));
						_.forEach(termItems, ti => jobCost.paymentTerms.add(ti));
					}
				}
			}
			else if (changeOrder.currentStatus === 'locked') {
				changeOrder.statusLog.add({ status: 'unlocked' });

				// 28jul2023 - this used to also check for !!summary.grandTotalSell but Mike F determined it was likely not needed
				if (changeOrder.type === 'change-order') {
					// clear tax and warranty costs
					summary.eraseCalculatedItems(jobCost.proxiedContract, changeOrderKey);
					summary.eraseStats(jobCost.proxiedContract, changeOrderKey);

					// 28jul2023 - added check for !!summary.grandTotalSell to prevent problems with payment terms based on above change
					// clear the payment terms
					if(summary.grandTotalSell) {
						_.forEach(jobCost.paymentTerms, ti => jobCost.paymentTerms.delete(ti.key));
					}
				}
			}
		}, { autoSave: true });
	}

	render () {
		const { changeOrder, contractAmount, rejectionResolved, termAmount, termConfig, termItems, isLocked } = this.state;
		const submitButtonClasses = ['action', 'iconLabel'];
		const enableTerms = !isLocked && (changeOrder.currentStatus !== 'rejected' || rejectionResolved === '1');
		const balance = Number((contractAmount - termAmount).toFixed(2));

		if (isLocked) {
			submitButtonClasses.push('unlock');
		}
		else {
			submitButtonClasses.push('finalize');
		}
		if (!this.canFinalize()) {
			submitButtonClasses.push('disabled');
		}

		const submitButtonText = changeOrder.currentStatus === 'locked' ? 'UNLOCK' : 'FINALIZE';
		const submitButton = ['unlocked', 'locked', 'rejected'].indexOf(changeOrder.currentStatus) !== -1 ? (<button className={ submitButtonClasses.join(' ') } onClick={ this.handleButtonClick }><span> { submitButtonText }</span></button>) : null;

		const infoTable = (<InfoTable onInfoCorrectChange={ this.onInfoCorrectChange } changeOrder={ this.state.changeOrder } { ...this.state } />);
		const mainHeaderText = changeOrder.currentStatus === 'rejected' ? 'REJECTED' : 'REVIEW CHANGE INFORMATION';
		let mainTable:any = infoTable;
		let secondaryTable:any = null;
		let secondarySection:any = null;

		if (changeOrder.currentStatus === 'rejected') {
			secondaryTable = infoTable;
			mainTable = <RejectionTable getEmployeeByUserId={ this.getEmployeeByUserId } onRejectionResolvedChange={ this.onRejectionResolvedChange } rejectionStatus={ changeOrder.currentStatusItem } { ...this.state } />;
		}

		if (secondaryTable) {
			secondarySection = (<section className={ rejectionResolved !== '1' ? 'disabled' : '' }>
				<header>
					<span>REVIEW CHANGE INFORMATION</span>
				</header>
				<div className={ `inner compact ${(isLocked ? 'readOnly' : '')}` }>
					{ secondaryTable }
				</div>
			</section>);
		}
		return (
			<section className={ 'jobCostFinalize' + (changeOrder.currentStatus === 'rejected' ? ' rejected' : '') }>
				<header>
					<span>{ mainHeaderText }</span>
				</header>
				<div className={ `inner compact ${(isLocked ? 'readOnly' : '')}` }>
					{ mainTable }
				</div>

				{ secondarySection }

				{ !termConfig ? null : <TermsSection terms={ termItems } onTermsChange={ this.onTermsChange } minAmount={ Number((contractAmount * 0.1).toFixed(2)) } className={ enableTerms ? '' : 'disabled' } isLocked={isLocked} canEdit={termConfig.canEdit} canAdd={termConfig.canAdd} calculateTerms={this.calculateTerms} /> }
				{ !termConfig ? null : <BalanceSection contractAmount={ contractAmount } termAmount={ termAmount } balance={ balance } className={ enableTerms ? '' : 'disabled' } isLocked={isLocked} paymentAmount={ undefined } /> }

				<section>
					<div className="inner compact">

						<table className="" cellPadding="0" cellSpacing="0">
							<tbody>
								<tr>
									<td />
									<td />
									<td>{ submitButton }</td>
									<td />
								</tr>
							</tbody>
						</table>

					</div>

				</section>

			</section>
		);
	}
}
